import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@coolremote/shared';

const randomId = `select-${parseInt(Math.random() * 100000)}`;

const SelectFormControl = ({options,error,value,onChange,disabled,className ,label,id,labelClassName,fullWidth,showLargeLabels,wrapperClassName, ...props}) => {
	return (
		<Select
			disabled={disabled}
			id={id}
			label={label}
			value={value}
			onChange={onChange}
			simulateNativeOnChange
			error={error}
			options={options}
			fullWidth={fullWidth}
			className={className}
			{...props}
		/>
	);
};

SelectFormControl.propTypes = {
	onChange:PropTypes.func.isRequired,
	options:PropTypes.arrayOf(PropTypes.shape({
		value:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
		text:PropTypes.string
	})),
	value:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
	error:PropTypes.string,
	label:PropTypes.string,
	id:PropTypes.string,
	disabled:PropTypes.bool,
	fullWidth:PropTypes.bool,
	labelClassName:PropTypes.string,
	showLargeLabels:PropTypes.bool,
	wrapperClassName:PropTypes.string,
	className:PropTypes.string,
};

SelectFormControl.defaultProps = {
	options:[],
	value:'',
	error:'',
	label:'',
	labelClassName:'',
	id:randomId,
	disabled:false,
	fullWidth:true,
	showLargeLabels:false,
	wrapperClassName:'',
	className:''
};

export default SelectFormControl;
